// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './vuex/store'
import VueCookie from 'vue-cookie'

import VeRing from 'v-charts/lib/ring.common'
import VePie from 'v-charts/lib/pie.common'
import VeGauge from 'v-charts/lib/gauge.common'
import VeLine from 'v-charts/lib/line.common'
import VeBar from 'v-charts/lib/bar.common'
import VeHistogram from 'v-charts/lib/histogram.common'
import echarts from 'echarts'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/main.css'
import '@/assets/css/monitor.css'
import '@/assets/js'
import {formatMoney} from "./filters/CommonFilters";
import {getImageUrl, getFileUrl} from "./filters/CommonActions";
import xhr from './utils/xhr.base'
import PreviewImageComponent from './components/PreviewImageComponent'


Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.use(VueCookie)
Vue.use(require('vue-moment'))

Vue.component(VeRing.name, VeRing)
Vue.component(VePie.name, VePie)
Vue.component(VeGauge.name, VeGauge)
Vue.component(VeLine.name, VeLine)
Vue.component(VeBar.name, VeBar)
Vue.component(VeHistogram.name, VeHistogram)

Vue.component('PreviewImageComponent', PreviewImageComponent)

Vue.prototype.$echarts = echarts
Vue.prototype.$xhr = xhr

const requireGlobalComponent = require.context(
  './components',
  false,
  /\.vue$/
)

requireGlobalComponent.keys().forEach(fileName=>{
  const componentConfig = requireGlobalComponent(fileName)
  const componentName = fileName.replace(/^\.\/(.*)\.\w+$/, '$1')

  Vue.component(
    componentName,
    componentConfig.default || componentConfig
  )
})

Vue.filter('formatMoney', formatMoney)
Vue.filter('getImageUrl', getImageUrl)
Vue.filter('getFileUrl', getFileUrl)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js